import autosize from 'autosize';

export default function () {
    //Do yo JAHVAHSCRIPT here.

	autosize($('textarea'));
}